import request from "../../Request";
import authStore from "../../../Stores/AuthStore/AuthStore";
import {rThen} from "../../requestThen";

export let deletePedagog = async (kindegartenId, DeleteTeacherID) => {

    return request.delete(`/api/gartens/add_pedagog/${kindegartenId}/${DeleteTeacherID}`,).then(r => {
        return rThen(r);
    })
}